import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { GeneralService } from "src/app/services/general.service";
import { EmailNotificationService } from "src/app/services/settings-services/email-notification.service";
import { FacebookService } from "src/app/services/social/facebook.service";
import { TwitterService } from "src/app/services/social/twitter.service";
import { LinkedInService } from "src/app/services/social/linkedin.service";
import FacebookHandler from "./facebook";
import TwitterHandler from "./twitter";
import { TiktokService } from "src/app/services/social/tiktok.service";
import { AppState } from "src/app/store/app.state";
import { Store } from "@ngrx/store";
import InstagramHandler from './instagram';
import {InstagramService} from '../../../services/social/instagram.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: "app-social-feed",
  templateUrl: "./social-feed.component.html",
  styleUrls: ["./social-feed.component.css"],
})
export class SocialFeedComponent implements OnInit, OnDestroy {
  private socket: any;
  feedItems: Array<any> = [];
  facebookFeedItems: Array<any> = [];
  facebookLoading = false;
  instagramFeedItems: Array<any> = [];
  twitterFeedItems: Array<any> = [];
  tiktokFeedItems: Array<any> = [];
  allFeedItems: Array<any> = [];
  private tiktokMentionsLoaded = false;
  tiktokMentions: Array<any> = [];
  private toastrConfig = {
    enableHtml: true,
    tapToDismiss: true,
    closeButton: true,
    disableTimeOut: true,
  };
  /** */
  facebook: any;
  twitter: any;
  instagram: any;
  private webUrl = environment.baseUrl;
  isInstagram: boolean;
  instagramDataLoaded: boolean;
  instagramActivePage: any = {};
  instagramHasNext: boolean;
  instagramHasPrevious: boolean;
  pageInsights: any = {};
  pageInsightsLoaded = false;
  private instagramCursorHistory: string[] = [];
  instagramFeed: Array<any> = [];
  instagramAnalytics = {
    totalLikes: 0,
    totalComments: 0,
  };

  /** */
  isFacebook = false;
  facebookActivePage: any = {};
  facebookFeed: any;
  handles: any;
  hashtags: any;
  stream_data: any = {
    hashtags: [],
    handles: [],
  };
  currentPage = 1;
  pageSize = 10;
  loading = false;
  hasMore = true;
  selectedOption = "1";
  facebookAnalyticsComment: any;
  facebookAnalyticsReactions: any;
  showFilters = false;
  showNotifications = false;
  notifications: Array<{ id: string; message: string; platform: string; timestamp: Date; read: boolean; payload?: any }> = [];
  unreadCount = 0;
  totalItems: any = 0;
  originalTotalItems: any = 0;
  searchTerm = "";
  isSearching = false;
  allItemsLoaded = false;
  startDate: string | number | Date;
  endDate: string;
  headerColor = "#158DED";
  activeDepartment: any;
  tiktokFeeds: Array<any> = [];
  tiktokAnalytics = {
    totalLikes: 0,
    totalShares: 0,
    totalComments: 0,
  };
  linkedInAnalytics = {
  totalReactions: 0,
  totalComments: 0,
  totalMentions: 0,
    reactions: {
      LIKE: 0,
      PRAISE: 0,
      EMPATHY: 0,
      INTEREST: 0,
      APPRECIATION: 0,
      ENTERTAINMENT: 0,
    }
  };
  private linkedInDataLoaded = false;
  private tiktokDataLoaded = false;
  private tiktokAnalyticsLoaded = false;

  /**
   * Per-platform load flags for the current page/session. These prevent a tab
   * from re-firing its HTTP calls every time it is re-entered. The active tab is
   * always refreshed when it is re-opened and by the live socket/event
   * subscriptions, so data stays current without any background prefetching.
   */
  private facebookDataLoaded = false;
  private facebookAnalyticsLoaded = false;
  private instagramDataLoaded_ = false;

  /** Socket / event subscriptions (kept alive for real-time notifications). */
  private subscriptions: Subscription = new Subscription();

  constructor(
    private commsNotification: EmailNotificationService,
    private facebookService: FacebookService,
    private twitterService: TwitterService,
    private tiktokService: TiktokService,
    private instagramService: InstagramService,
    private toaster: ToastrService,
    private linkedInService: LinkedInService,
    private generalSrv: GeneralService,
    private store: Store<AppState>
  ) {
    this.facebook = new FacebookHandler(this.facebookService);
    this.instagram = new InstagramHandler(this.instagramService);
    this.subscriptions.add(
      store.select("departmentInfo").subscribe((info) => {
        this.activeDepartment = info.id ? info : "";
      })
    );
  }

  ngOnInit() {
    this.loading = true;
    this.registerRealtimeSubscriptions();

    // Only the active (default) tab loads data. Everything else is deferred
    // until the user actually switches to it.
    this.loadActiveTab();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();

    if (this.socket && this.socket.off) {
      [
        "new_tweet",
        "facebook_update",
        "instagram_mention",
        "tweet:handled",
        "linkedin_comment",
        "linkedin_reaction",
        "linkedin_mention",
        "linkedin_share",
        "linkedin_update",
      ].forEach((event) => this.socket.off(event));
    }
  }

  /**
   * Real-time event subscriptions. These stay registered for every platform
   * (regardless of the active tab) so notifications for new activity keep
   * arriving; only the data refresh is scoped to the active tab.
   */
  private registerRealtimeSubscriptions() {
    this.socket = this.commsNotification.get_socket();
    if (this.socket) {
      this.socket.on("new_tweet", (tweet) => {
        if (this.selectedOption !== "5") {
          // Nothing to render in the current context; the X tab reloads on entry.
          return;
        }
        const parsedTweet = this.getTwitterHandler().parseTweet(tweet);
        this.feedItems.unshift(parsedTweet);
        this.allFeedItems.unshift(parsedTweet);

        if (!this.isSearching) {
          this.totalItems++;
          this.originalTotalItems++;
        }

        if (this.searchTerm) {
          this.applySearchFilter();
        }
      });

      this.socket.on("facebook_update", (data) => {
        if (data.facebookObject){
          const msg = `<p><a href="${this.webUrl}/social-feed" target="_blank">view notification</a></p>`;
          this.toaster.success(msg, "New Facebook Notification", this.toastrConfig);
        }
        if (this.selectedOption === "1") {
          this.getFacebookPagePosts(this.facebookActivePage.id, true);
          this.getFacebookPageAnalytics(this.facebookActivePage.id);
        }
      });

      this.socket.on("instagram_mention", (data) => {
        if (data.instagramObject) {
          const msg = `<p><a href="${this.webUrl}/social-feed" target="_blank">view notification</a></p>`;
          this.toaster.success(msg, "New Instagram Notification", this.toastrConfig);
        }
        if (this.selectedOption === "4") {
          this.getInstagramPosts(this.instagramActivePage.id, true);
        }
      });

      this.socket.on("tweet:handled", (id: number) => {
        this.twitterService.replied_tweet(id);
        this.facebookService.repliedPost(id);
      });

      this.socket.on('linkedin_comment', (data) => {
        if (this.selectedOption === '3') {
          const newComment = {
              ...data.feedData,
              itemType: 'comment',
              parentPost: data.linkedinObject
          };
          this.feedItems.unshift(newComment);
          this.allFeedItems.unshift(newComment);
          this.totalItems++;
          this.linkedInAnalytics.totalComments++;
        }
        this.toaster.info(
          `New comment: "${(data.feedData.message.text || '').substring(0, 50)}"`,
          'LinkedIn Comment'
        );
      });

      this.socket.on('linkedin_reaction', (data) => {
        if (this.selectedOption === '3') {
          const newReaction = {
              ...data.feedData,
              itemType: 'reaction',
              reactionType: data.feedData.reactionType || 'LIKE',
              parentPost: data.linkedinObject,
              actorName: data.feedData.senderName || 'LinkedIn User',
              created: { time: data.feedData.created.time || Date.now() },
          };
          this.feedItems.unshift(newReaction);
          this.allFeedItems.unshift(newReaction);
          this.totalItems++;
          this.linkedInAnalytics.totalReactions++;
          this.linkedInAnalytics.reactions.LIKE++;
        }
        const reactorName = data.feedData.senderName || 'Someone';
        this.toaster.info(`${reactorName} reacted to your post, LinkedIn Reaction`);
      });

      this.socket.on('linkedin_mention', (data) => {
        if (this.selectedOption === '3') {
          const newMention = {
              ...data.feedData,
              itemType: 'mention',
              parentPost: data.linkedinObject
          };
          this.feedItems.unshift(newMention);
          this.allFeedItems.unshift(newMention);
          this.totalItems++;
          this.linkedInAnalytics.totalMentions++;
        }
        const mentionText = (data.feedData.message.text || '').substring(0, 50);
        this.toaster.warning(`You were mentioned: "${mentionText}"`);
      });

      this.socket.on('linkedin_share', (data) => {
        if (this.selectedOption === '3') {
          this.linkedInAnalytics.totalReactions++;
        }
        this.toaster.success(
            'Someone shared your post',
            'LinkedIn Share'
        );
      });

      this.socket.on('linkedin_update', (data) => {
        if (this.selectedOption === '3') {
          this.linkedInDataLoaded = false;
          this.getLinkedInFeeds();
        }
      });
    }

    this.subscriptions.add(
      this.tiktokService.newPost.subscribe((data) => {
        if (data && this.selectedOption === "2") {
          this.tiktokDataLoaded = false;
          this.tiktokService.fetchTiktokPosts().subscribe({
            next: (response: any) => {
              if (response.success) {
                this.tiktokFeeds = (response.comments || []).map((item) => ({
                  ...item,
                  itemType: "comment",
                }));
                this.tiktokDataLoaded = true;
              } else {
                this.tiktokFeeds = [];
                this.tiktokDataLoaded = true;
              }
            },
            error: (error) => {
              console.error("TikTok fetch error:", error);
              this.toaster.error("Cannot fetch TikTok comments.");
              this.tiktokFeeds = [];
              this.tiktokDataLoaded = true;
            }
          });
        }
      })
    );

    this.subscriptions.add(
      this.tiktokService.newComment.subscribe((data) => {
        if (data && this.selectedOption === "2") {
          this.tiktokDataLoaded = false;
          this.tiktokService.fetchVideoComments().subscribe({
            next: (response: any) => {
              if (response.success) {
                this.tiktokFeeds = (response.comments || []).map((item) => ({
                  ...item,
                  itemType: "comment",
                }));
                this.tiktokDataLoaded = true;
                this.combineTiktokData();
              } else {
                this.tiktokFeeds = [];
                this.tiktokDataLoaded = true;
              }
            },
            error: (error) => {
              console.error("TikTok fetch error:", error);
              this.toaster.error("Cannot fetch TikTok comments.");
              this.tiktokFeeds = [];
              this.tiktokDataLoaded = true;
            }
          });
        }
      })
    );

    this.subscriptions.add(
      this.tiktokService.newMention.subscribe((data) => {
        if (data && this.selectedOption === "2") {
          this.tiktokMentionsLoaded = false;
          this.loading = true;
          this.combineTiktokData();
          this.fetchTiktokMentions();
        }
      })
    );
  }

  /**
   * Loads the data for the currently selected platform only.
   */
  private loadActiveTab() {
    switch (this.selectedOption) {
      case "1":
        this.loadFacebookTab();
        break;
      case "2":
        this.loadTiktokTab();
        break;
      case "3":
        this.loadLinkedInTab();
        break;
      case "4":
        this.loadInstagramTab();
        break;
      case "5":
        this.loadTwitterTab();
        break;
      default:
        this.loading = false;
    }
  }

  private loadFacebookTab() {
    this.facebookLoading = true;
    this.facebookDataLoaded = false;
    this.facebookAnalyticsLoaded = false;
    this.getOrganizationFacebookPage();
  }

  private loadInstagramTab() {
    this.loading = true;
    this.instagramDataLoaded_ = false;
    this.pageInsightsLoaded = false;
    this.getOrganizationInstagramPage();
  }

  private loadLinkedInTab() {
    this.linkedInDataLoaded = false;
    this.getLinkedInFeeds();
  }

  private loadTiktokTab() {
    this.tiktokDataLoaded = false;
    this.tiktokAnalyticsLoaded = false;
    this.tiktokMentionsLoaded = false;
    this.tiktokFeeds = [];
    this.tiktokMentions = [];
    this.tiktokAnalytics = { totalLikes: 0, totalShares: 0, totalComments: 0 };
    this.getTiktokFeeds();
  }

  /**
   * Returns the Twitter handler, creating it on first use. Construction triggers
   * X account + stream-settings requests, so it only happens once the X tab is
   * actually opened (or an X event arrives while it is open).
   */
  private getTwitterHandler(): TwitterHandler {
    if (!this.twitter) {
      this.twitter = new TwitterHandler(this.twitterService);
      // Keep the template-bound settings in sync with the handler afterwards.
      this.subscriptions.add(
        this.twitterService.user_data.subscribe((data) => {
          if (Object.keys(data).length) {
            this.twitter.set_twitter_settings(data);
          }
        })
      );
    }
    return this.twitter;
  }

  private loadTwitterTab() {
    this.loading = true;
    this.getTwitterHandler();
    this.getTwitterStreamSettings();
    this.feedItems = [...this.twitterFeedItems];
    this.allFeedItems = [...this.twitterFeedItems];
    this.totalItems = this.twitterFeedItems.length;
    this.originalTotalItems = this.twitterFeedItems.length;
    this.loading = false;
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  getTiktokFeeds() {
    if (
      this.tiktokDataLoaded &&
      this.tiktokMentionsLoaded &&
      (this.tiktokFeeds.length > 0 || this.tiktokMentions.length > 0)
    ) {
      const combinedFeeds = [...this.tiktokFeeds, ...this.tiktokMentions].sort(
        (a, b) => {
          const dateA = this.getItemDate(a).getTime() || 0;
          const dateB = this.getItemDate(b).getTime() || 0;
          return dateB - dateA;
        }
      );

      this.feedItems = combinedFeeds;
      this.allFeedItems = combinedFeeds;
      this.totalItems = combinedFeeds.length;
      return;
    }

    this.loading = true;

    this.tiktokService.fetchVideoComments().subscribe(
      (response: any) => {
        if (response.success) {
          this.tiktokFeeds = (response.comments || []).map((item) => ({
            ...item,
            itemType: "comment",
          }));
          this.tiktokDataLoaded = true;
        } else {
          this.tiktokFeeds = [];
          this.tiktokDataLoaded = true;
        }

        this.fetchTiktokMentions();
      },
      (error) => {
        console.error("TikTok fetch error:", error);
        this.toaster.error("Cannot fetch TikTok comments.");
        this.tiktokFeeds = [];
        this.tiktokDataLoaded = true;
        this.fetchTiktokMentions();
      }
    );
  }

  fetchTiktokMentions() {
    this.tiktokService.fetchMentionsInComments().subscribe(
      (response: any) => {
        if (response.success) {
          const commentMentions = (response.data || []).map((item) => ({
            ...item,
            itemType: "mention",
          }));

          this.tiktokService.fetchMentionsInVideos().subscribe(
            (videoResponse: any) => {
              if (videoResponse.success) {
                const videoMentions = (videoResponse.data || []).map(
                  (item) => ({
                    ...item,
                    itemType: "mention",
                  })
                );

                this.tiktokMentions = [...commentMentions, ...videoMentions];
              } else {
                this.tiktokMentions = commentMentions;
              }

              this.tiktokMentionsLoaded = true;
              this.combineTiktokData();
            },
            (error) => {
              console.error("TikTok video mentions fetch error:", error);
              this.tiktokMentions = commentMentions;
              this.tiktokMentionsLoaded = true;
              this.combineTiktokData();
            }
          );
        } else {
          this.tiktokMentions = [];
          this.tiktokMentionsLoaded = true;
          this.combineTiktokData();
        }
      },
      (error) => {
        console.error("TikTok comment mentions fetch error:", error);
        this.tiktokMentions = [];
        this.tiktokMentionsLoaded = true;
        this.combineTiktokData();
      }
    );
  }

  combineTiktokData() {
    const combinedFeeds = [...this.tiktokFeeds, ...this.tiktokMentions].sort(
      (a, b) => {
        const dateA = this.getItemDate(a).getTime() || 0;
        const dateB = this.getItemDate(b).getTime() || 0;
        return dateB - dateA;
      }
    );

    this.allFeedItems = combinedFeeds;
    this.feedItems = combinedFeeds;
    this.totalItems = combinedFeeds.length;
    this.originalTotalItems = combinedFeeds.length;
    this.loading = false;
    this.getTiktokAnalytics();
  }
  getTiktokAnalytics() {
    if (this.tiktokAnalyticsLoaded) {
      return;
    }

    this.loading = true;
    this.tiktokService.fetchFeeds().subscribe(
      (response: any) => {
        let feedData = [];

        if (response.success) {
          if (Array.isArray(response.data)) {
            feedData = response.data;
          } else if (response.payload && Array.isArray(response.payload)) {
            feedData = response.payload;
          } else if (response.data && Array.isArray(response.data.videos)) {
            feedData = response.data.videos;
          }
        }

        if (feedData.length > 0) {
          this.tiktokAnalytics = this.calculateTiktokAnalytics(feedData);
          this.tiktokAnalyticsLoaded = true;
        } else {
          this.resetTiktokAnalytics();
        }
        this.loading = false;
      },
      (error) => {
        console.error("TikTok analytics fetch error:", error);
        this.resetTiktokAnalytics();
        this.loading = false;
      }
    );
  }

  calculateTiktokAnalytics(feeds: any[]): {
    totalLikes: number;
    totalShares: number;
    totalComments: number;
  } {
    const analytics = {
      totalLikes: 0,
      totalShares: 0,
      totalComments: 0,
    };

    feeds.forEach((feed) => {
      if (feed.likes !== undefined) {
        analytics.totalLikes += feed.likes;
      }

      if (feed.shares !== undefined) {
        analytics.totalShares += feed.shares;
      }

      if (feed.comments !== undefined) {
        if (Array.isArray(feed.comments)) {
          analytics.totalComments += feed.comments.length;
        } else if (typeof feed.comments === "number") {
          analytics.totalComments += feed.comments;
        }
      } else if (
        feed.statistics &&
        feed.statistics.comment_count !== undefined
      ) {
        analytics.totalComments += feed.statistics.comment_count;
      }
    });

    return analytics;
  }

  private resetTiktokAnalytics() {
    this.tiktokAnalytics = {
      totalLikes: 0,
      totalShares: 0,
      totalComments: 0,
    };
  }

  getLinkedInFeeds() {
    this.loading = true;
    this.linkedInService.fetchPagePostsWithComments().subscribe(
      (response: any) => {
        if (response.success && response.payload) {
          const elements = response.payload.elements || [];
          const feedItems = [];
          const reactionTotals = {
            LIKE: 0, PRAISE: 0, EMPATHY: 0,
            INTEREST: 0, APPRECIATION: 0, ENTERTAINMENT: 0
          };
          let totalComments = 0;
          let totalReactions = 0;

        elements.forEach(post => {
          totalComments += post.totalComments || 0;
          totalReactions += post.totalReactions || 0;

          if (post.reactions) {
            Object.keys(post.reactions).forEach(key => {
              if (reactionTotals.hasOwnProperty(key)) {
                reactionTotals[key] += post.reactions[key];
              }
            });
          }
          if (post.reactors && post.reactors.length) {
            post.reactors.forEach(reactor => {
              feedItems.push({
                itemType: 'reaction',
                reactionType: reactor.reactionType,
                parentPost: post,
                actorName: reactor.actorName || 'LinkedIn Member',
                actorUrn: reactor.actor,
                 created: {
                time: reactor.created.time
                  || reactor.lastModified.time
              },
                message: { text: '' },
              });
            });
          } else if (post.reactions) {

            Object.keys(post.reactions).forEach(reactionType => {
              const count = post.reactions[reactionType];
              feedItems.push({
                itemType: 'reaction',
                reactionType,
                parentPost: post,
                actorName: `${count} ${reactionType.toLowerCase()}${count > 1 ? 's' : ''}`,
                created: { time: post.lastModifiedAt || post.publishedAt || Date.now() },
                message: { text: '' },
              });
            });
          }

          if (post.comments && post.comments.length) {
            post.comments.forEach(comment => {
              feedItems.push({
                ...comment,
                itemType: 'comment',
                parentPost: post,
              });
            });
          }
        });

        this.linkedInAnalytics = {
          totalReactions,
          totalComments,
          totalMentions: 0,
          reactions: reactionTotals
        };

        feedItems.sort((a, b) => {
          const dateA = this.getItemDate(a).getTime() || 0;
          const dateB = this.getItemDate(b).getTime() || 0;
          return dateB - dateA;
        });

        this.feedItems = feedItems;
        this.allFeedItems = feedItems;
        this.totalItems = feedItems.length;
        this.originalTotalItems = feedItems.length;
        this.linkedInDataLoaded = true;
      }
      this.loading = false;
    },
    (error) => {
      this.toaster.error('Cannot fetch LinkedIn posts.');
      this.loading = false;
    }
  );
}

  /**
   * Loads the Instagram business account page plus the page insights used by
   * the Instagram analytics card. Called only when the Instagram tab is active.
   */
  getOrganizationInstagramPage() {
    this.facebookService.fetchOrganizationPages(this.activeDepartment)
      .subscribe(
        (response: any) => {
          const {status_code, success, payload} = response;
          if (success && (status_code == 200 || status_code == 201)) {
            this.instagramActivePage = payload.active_page.instagram_business_account;
            this.instagramDataLoaded_ = true;
          }
          this.getInstagramPosts(this.instagramActivePage.id, true);
        },
        (error: any) => {
          this.loading = false;
          this.getInstagramPosts(this.instagramActivePage.id, true);
        },
      );
    this.instagramService.instagramPageInsights().subscribe({
      next: (res: any) => {
        this.pageInsights = res.data;
        this.pageInsightsLoaded = true;
      },
      error: (err: any) => {
        this.loading = false;
        this.toaster.error('Cannot fetch insights.');
      }
    });
  }

  getOrganizationFacebookPage() {
    this.facebookLoading = true;
    this.facebookService
      .fetchOrganizationPages(this.activeDepartment)
      .subscribe(
        (response: any) => {
          const {status_code, success, payload} = response;
          if (success && (status_code == 200 || status_code == 201)) {
            this.facebookActivePage = payload.active_page;
            this.getFacebookPagePosts(this.facebookActivePage.id).then(() => {
              // this.facebookLoading = false;
            });
            this.getFacebookPageAnalytics(this.facebookActivePage.id);
          } else {
            this.facebookLoading = false;
            this.loading = false;
            this.toaster.error(
              "Connect a Facebook page in the Ticket Inbound Comms settings page."
            );
          }
        },
        (e) => {
          this.facebookLoading = false;
          this.loading = false;
          this.toaster.error(
            "Connect a Facebook page in the Ticket Inbound Comms settings page."
          );
        }
      );
  }


  formatDateForDisplay(dateString: string): string {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  convertToISODate(ddmmyyyy: string): string {
    if (!ddmmyyyy || ddmmyyyy.length !== 10) return "";
    const parts = ddmmyyyy.split("/");
    if (parts.length !== 3) return "";
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    return `${year}-${month}-${day}`;
  }

  onDateInput(event: any, field: "start" | "end"): void {
    let value = event.target.value.replace(/\D/g, "");

    if (value.length >= 2) {
      value = value.slice(0, 2) + "/" + value.slice(2);
    }
    if (value.length >= 5) {
      value = value.slice(0, 5) + "/" + value.slice(5, 9);
    }

    event.target.value = value;

    if (field === "start") {
      this.startDate = this.convertToISODate(value);
    } else {
      this.endDate = this.convertToISODate(value);
    }
  }

  isValidDate(dateString: string): boolean {
    if (!dateString || dateString.length !== 10) return false;
    const parts = dateString.split("/");
    if (parts.length !== 3) return false;

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    if (
      day < 1 ||
      day > 31 ||
      month < 1 ||
      month > 12 ||
      year < 1900 ||
      year > 2100
    ) {
      return false;
    }

    const date = new Date(year, month - 1, day);
    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  }

  onSubmitFilter(): void {
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      this.toaster.error("Start date cannot be after end date");
      return;
    }

    this.isSearching =
      this.searchTerm.trim() !== "" ||
      this.startDate !== "" ||
      this.endDate !== "";
    this.currentPage = 1;

    if (this.selectedOption === "2") {
      this.applyTiktokFilters();
      return;
    }

    if (this.selectedOption === "3") {
      this.applyLinkedInFilters();
      return;
    }
    if (this.selectedOption === "4") {
      if (!this.allItemsLoaded) {
        this.getInstagramPosts(this.instagramActivePage.id, true);
      } else {
        this.applyInstagramFIlters();
      }
      return;
    }

    if (!this.allItemsLoaded) {
      this.getFacebookPagePosts(this.facebookActivePage.id, true);
    } else {
      this.applyFilters();
    }
  }

  applyTiktokFilters(): void {
    const combinedFeeds = [...this.tiktokFeeds, ...this.tiktokMentions];
    let filteredItems = [...combinedFeeds];

    if (this.searchTerm && this.searchTerm.trim() !== "") {
      const searchTerm = this.searchTerm.toLowerCase().trim();
      filteredItems = filteredItems.filter((item) => {
        const searchableText = this.getSearchableText(item).toLowerCase();
        return searchableText.includes(searchTerm);
      });
    }

    if (this.startDate || this.endDate) {
      filteredItems = filteredItems.filter((item) => {
        const itemDate = this.getItemDate(item);
        if (!itemDate) return true;

        const start = this.startDate
          ? new Date(this.startDate + "T00:00:00.000Z")
          : null;
        const end = this.endDate
          ? new Date(this.endDate + "T23:59:59.999Z")
          : null;

        if (start && itemDate < start) return false;
        if (end && itemDate > end) return false;
        return true;
      });
    }

    this.feedItems = filteredItems;
    this.allFeedItems = filteredItems;
    this.totalItems = filteredItems.length;
  }

  applyLinkedInFilters(): void {
  let filteredItems = [...this.allFeedItems];

  if (this.searchTerm && this.searchTerm.trim() !== "") {
    const searchTerm = this.searchTerm.toLowerCase().trim();
    filteredItems = filteredItems.filter((item) => {
      const text = (item.message.text || '').toLowerCase();
      const name = (item.actorName || '').toLowerCase();
      const postText = (item.parentPost.commentary || '').toLowerCase();
      return text.includes(searchTerm) || name.includes(searchTerm) || postText.includes(searchTerm);
    });
  }

  if (this.startDate || this.endDate) {
    filteredItems = filteredItems.filter((item) => {
      const raw = item.created && item.created.time;
      if (!raw) return true;
      const itemDate = new Date(raw);

      const start = this.startDate ? new Date(this.startDate + "T00:00:00.000Z") : null;
      const end = this.endDate ? new Date(this.endDate + "T23:59:59.999Z") : null;

      if (start && itemDate < start) return false;
      if (end && itemDate > end) return false;
      return true;
    });
  }

  this.feedItems = filteredItems;
  this.totalItems = filteredItems.length;
  this.currentPage = 1;
}

  applyInstagramFIlters() {
    if (this.allItemsLoaded) {
      this.getInstagramPosts(this.instagramActivePage.id, true);
      return;
    }

    let filteredItems = [...this.instagramFeedItems];
    if (this.searchTerm && this.searchTerm.trim() !== "") {
      const searchTerm = this.searchTerm.toLowerCase().trim();
      filteredItems = filteredItems.filter((item) => {
        const searchableText = this.getSearchableText(item).toLowerCase();
        return searchableText.includes(searchTerm);
      });
    }
    if (this.startDate || this.endDate) {
      filteredItems = filteredItems.filter((item) => {
        const itemDate = this.getItemDate(item);
        if (!itemDate) {
          return true;
        }
        const start = this.startDate
          ? new Date(this.startDate + "T00:00:00.000Z")
          : null;
        const end = this.endDate
          ? new Date(this.endDate + "T23:59:59.999Z")
          : null;

        if (start && itemDate <= start) return false;
        if (end && itemDate >= end) return false;
        return true;
      });
    }

  this.feedItems = filteredItems;
  this.instagramFeedItems = filteredItems;
  this.totalItems = filteredItems.length;
  this.isSearching =
    this.searchTerm.trim() !== "" ||
    this.startDate !== "" ||
    this.endDate !== "";
  this.currentPage = 1;
}
  applyInstagramSearchFilters() {
    if (!this.searchTerm || this.searchTerm.trim() === "") {
      this.isSearching = false;
      this.totalItems = this.originalTotalItems;

      if (
        this.allItemsLoaded &&
        this.allFeedItems.length >= this.originalTotalItems
      ) {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.feedItems = this.allFeedItems.slice(startIndex, endIndex);
      } else {
        this.getInstagramPosts(this.instagramActivePage.id, true);
      }
      return;
    }



    this.isSearching = true;
    this.currentPage = 1;

    if (!this.allItemsLoaded) {
      this.getInstagramPosts(this.instagramActivePage.id, true);
      return;
    }
    const searchTerm = this.searchTerm.toLowerCase().trim();
    this.instagramFeedItems = this.allFeedItems.filter((item) => {
      const searchableText = this.getSearchableText(item).toLowerCase();
      return searchableText.includes(searchTerm);
    });

    this.totalItems = this.instagramFeedItems.length;
  }
  onClearFilters(): void {
  this.searchTerm = "";
  this.startDate = "";
  this.endDate = "";
  this.isSearching = false;
  this.currentPage = 1;

  if (this.selectedOption === "2") {
    const combinedFeeds = [...this.tiktokFeeds, ...this.tiktokMentions].sort(
      (a, b) => {
        const dateA = this.getItemDate(a).getTime() || 0;
        const dateB = this.getItemDate(b).getTime() || 0;
        return dateB - dateA;
      }
    );

    this.feedItems = combinedFeeds;
    this.allFeedItems = combinedFeeds;
    this.totalItems = combinedFeeds.length;
    this.originalTotalItems = combinedFeeds.length;

  } else if (this.selectedOption === "3") {
      this.feedItems = [...this.allFeedItems];
      this.totalItems = this.allFeedItems.length;
      this.isSearching = false;
    } else if (this.selectedOption === '1') {
      this.allItemsLoaded = false;
      this.totalItems = this.originalTotalItems;
      this.getFacebookPagePosts(this.facebookActivePage.id, true);
    } else if (this.selectedOption === '4') {
      this.allItemsLoaded = false;
      this.totalItems = this.originalTotalItems;
      this.getInstagramPosts(this.instagramActivePage.id, true);
    }

}

  applyFilters(): void {
    if (this.allItemsLoaded) {
      this.getFacebookPagePosts(this.facebookActivePage.id, true);
      return;
    }

    let filteredItems = [...this.facebookFeedItems];
    if (this.searchTerm && this.searchTerm.trim() !== "") {
      const searchTerm = this.searchTerm.toLowerCase().trim();
      filteredItems = filteredItems.filter((item) => {
        const searchableText = this.getSearchableText(item).toLowerCase();
        return searchableText.includes(searchTerm);
      });
    }
    if (this.startDate || this.endDate) {
      filteredItems = filteredItems.filter((item) => {
        const itemDate = this.getItemDate(item);

        if (!itemDate) {
          return true;
        }
        const start = this.startDate
          ? new Date(this.startDate + "T00:00:00.000Z")
          : null;
        const end = this.endDate
          ? new Date(this.endDate + "T23:59:59.999Z")
          : null;

        if (start && itemDate <= start) return false;
        if (end && itemDate >= end) return false;
        return true;
      });
    }

    this.feedItems = filteredItems;
    this.facebookFeedItems = filteredItems;
    this.totalItems = filteredItems.length;
    this.isSearching =
      this.searchTerm.trim() !== "" ||
      this.startDate !== "" ||
      this.endDate !== "";
    this.currentPage = 1;
  }

  getCurrentPageItemCount(): number {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.totalItems);

    if (this.isSearching || this.selectedOption === "2") {
      return Math.min(this.feedItems.length, endIndex);
    }
    if (this.isSearching || this.selectedOption === '4') {
      return Math.min(this.instagramFeedItems.length, endIndex);
    }

    return endIndex;
  }

  getItemDate(item: any): Date | null {
    let itemDate: Date | null = null;

    try {
       if (item.created && item.created.time) {
        itemDate = new Date(item.created.time);
      } else if (item.created_on) {
        itemDate = new Date(item.created_on);
      } else if (item.facebookObject && item.facebookObject.created_time) {
        const timestamp =
          typeof item.facebookObject.created_time === "number"
            ? item.facebookObject.created_time * 1000
            : parseInt(item.facebookObject.created_time) * 1000;
        itemDate = new Date(timestamp);
      } else if (item.time_stamp) {
        itemDate = new Date(item.time_stamp);
      } else if (item.updated_on) {
        itemDate = new Date(item.updated_on);
      } else if (item.create_time) {
        const timestamp =
          typeof item.create_time === "number"
            ? item.create_time < 10000000000
              ? item.create_time * 1000
              : item.create_time
            : parseInt(item.create_time) * 1000;
        itemDate = new Date(timestamp);
      } else if (item.comment_create_time) {
        const timestamp =
          typeof item.comment_create_time === "number"
            ? item.comment_create_time < 10000000000
              ? item.comment_create_time * 1000
              : item.comment_create_time
            : parseInt(item.comment_create_time) * 1000;
        itemDate = new Date(timestamp);
      } else if (item.createdAt) {
        itemDate = new Date(item.createdAt);
      }

      if (itemDate && isNaN(itemDate.getTime())) {
        return null;
      }

      return itemDate;
    } catch (error) {
      console.warn("Error parsing date for item:", item, error);
      return null;
    }
  }

  getInstagramPosts(pageId, reset: boolean= false) {
    this.loading = true;
    const shouldLoadAll = this.isSearching || this.startDate || this.endDate;
    const pageToLoad = shouldLoadAll ? 0 : this.currentPage - 1;
    const sizeToLoad = shouldLoadAll ? 1000 : this.pageSize;
    this.instagramService.fetchPosts(pageId, pageToLoad, sizeToLoad)
      .subscribe(
        (response: any) => {
          const {status_code, success, payload} = response.data;

          if (success && (status_code === 200 || status_code === 201)) {
            if (shouldLoadAll || reset) {
              this.instagramFeedItems = [...payload.items];
              this.allFeedItems = [...payload.items];
              this.originalTotalItems = payload.total;
            }

            if (!shouldLoadAll) {
              this.instagramFeedItems = [...payload.items];
              this.allFeedItems = [...payload.items];
              this.totalItems = payload.total;
            }

            if (shouldLoadAll) {
              this.applyInstagramFIlters();
            }

            this.hasMore = payload.items.length === this.pageSize;
            this.loading = false;
          }

        },
        (error: any) => {
          this.toaster.error('Cannot find feed for your page.');
          this.loading = false;
        }
      );
  }

  async getFacebookPagePosts(pageId: number, reset: boolean = false) {
    // if (this.loading) return;

    this.facebookLoading = true;
    const shouldLoadAll = this.isSearching || this.startDate || this.endDate;
    const pageToLoad = shouldLoadAll ? 0 : this.currentPage - 1;
    const sizeToLoad = shouldLoadAll ? 1000 : this.pageSize;

    this.facebookService
      .fetchOrganizationPagePosts(pageId, pageToLoad, sizeToLoad)
      .subscribe({
        next: (response: any) => {
          try {
            const { status_code, success, payload } = response;
            if (success && (status_code === 200 || status_code === 201)) {
              if (shouldLoadAll || reset) {
                this.facebookFeedItems = [...payload.items];
                this.allFeedItems = [...payload.items];
                this.originalTotalItems = payload.total;
              }

              if (!shouldLoadAll) {
                this.allFeedItems = [...payload.items];
                this.facebookFeedItems = [...payload.items];
                this.totalItems = payload.total;
              }

              if (shouldLoadAll) {
                this.applyFilters();
              }

              this.hasMore = payload.items.length === this.pageSize;
              this.facebookDataLoaded = true;
            }
          } finally {
            this.facebookLoading = false;
          }
        },
        error: () => {
          this.toaster.error("Cannot find feed for your page.");
          this.facebookLoading = false;
        }
      });
  }

  getFacebookPageAnalytics(pageId: number) {
    this.facebookService.fetchOrganizationPageAnalytics(pageId).subscribe(
      (response: any) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.loading = false;
          this.facebookAnalyticsComment = payload.comment;
          this.facebookAnalyticsReactions = payload.reactions;
          this.facebookAnalyticsLoaded = true;
        }
      },
      (e) => {
        this.toaster.error("Cannot find feed analytics for your page.");
        this.loading = false;
      }
    );
  }

  getTwitterStreamSettings() {
    this.twitterService.fetch_stream_setting().subscribe((response: any) => {
      if (response.success) {
        this.getTwitterHandler().set_twitter_settings(response.payload);
        this.stream_data = { ...response.payload };
        this.handles = response.payload.handles;
        this.hashtags = response.payload.hashtags;
      }
    });
  }
  processnewIgFeeds(pageId) {

  }
  processNewFeeds(pageId) {
    const currentSearchTerm = this.searchTerm;
    const currentStartDate = this.startDate;
    const currentEndDate = this.endDate;
    const wasSearching = this.isSearching;

    this.facebookService.fetchOrganizationPagePosts(pageId, 0, 1000).subscribe(
      (response: any) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.facebookFeedItems = [...payload.items];
          this.originalTotalItems = payload.total;
          this.allItemsLoaded = true;
          this.searchTerm = currentSearchTerm;
          this.startDate = currentStartDate;
          this.endDate = currentEndDate;
          this.isSearching = wasSearching;
          if (this.searchTerm || this.startDate || this.endDate) {
            this.applyFilters();
          } else {
            this.facebookFeedItems = [...payload.items];
            this.totalItems = this.originalTotalItems;
          }
        }
      },
      (e) => {
        this.toaster.error("Cannot find latest feed for your page.");
        this.loading = false;
      }
    );
  }

  onPageChanged(page: number): void {
    this.currentPage = page;
    if (this.selectedOption === "2") {
      return;
    }


    if (this.selectedOption === '3') {
      return;
    }

    if (this.isSearching || this.startDate || this.endDate) {
      return;
    }
    if (this.selectedOption === '4') {
      this.getInstagramPosts(this.instagramActivePage.id, false);
      return;
    }

    if (this.selectedOption === '5') {
      return;
    }

    this.getFacebookPagePosts(this.facebookActivePage.id, false);
  }

  onDropdownChange(event: any) {
    const nextOption = event.target.value;
    if (nextOption === this.selectedOption) {
      return;
    }

    this.selectedOption = nextOption;
    this.currentPage = 1;
    this.searchTerm = "";
    this.startDate = "";
    this.endDate = "";
    this.isSearching = false;
    this.allItemsLoaded = false;
    this.feedItems = [];
    this.allFeedItems = [];
    this.totalItems = 0;
    this.originalTotalItems = 0;

    if (this.selectedOption === "1") {
      this.headerColor = "#158DED";
    } else if (this.selectedOption === "2") {
      this.headerColor = "#000000";
    } else if (this.selectedOption === "5") {
      this.headerColor = "#000000";
    } else if (this.selectedOption === "3") {
      this.headerColor = "#0077B5";
    } else if (this.selectedOption === "4") {
      this.headerColor =
        "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)";
    }

    // Fetch only what the newly selected tab needs.
    this.loadActiveTab();
  }

  onSearchChange(): void {
    if (this.selectedOption === "2") {
      if (!this.searchTerm || this.searchTerm.trim() === "") {
        const combinedFeeds = [
          ...this.tiktokFeeds,
          ...this.tiktokMentions,
        ].sort((a, b) => {
          const dateA = this.getItemDate(a).getTime() || 0;
          const dateB = this.getItemDate(b).getTime() || 0;
          return dateB - dateA;
        });
        this.feedItems = combinedFeeds;
        this.allFeedItems = combinedFeeds;
        this.totalItems = combinedFeeds.length;
        this.isSearching = false;
      }  else {
        this.applyTiktokSearch();
      }
    } else if (this.selectedOption === "3") {
      if (!this.searchTerm || this.searchTerm.trim() === "") {
         this.feedItems = [...this.allFeedItems];
          this.totalItems = this.allFeedItems.length;
          this.isSearching = false;
      } else {
        this.applyLinkedInFilters();
      }
    } else if (this.selectedOption === "4") {
      if (!this.searchTerm || this.searchTerm.trim() === "") {
        this.instagramFeedItems = [...this.allFeedItems]; // CHANGED
        this.totalItems = this.originalTotalItems;
        this.isSearching = false;
      } else {
        this.applyInstagramSearchFilters();
      }
    } else if (this.selectedOption === "5") {
      if (!this.searchTerm || this.searchTerm.trim() === "") {
        this.feedItems = [...this.allFeedItems];
        this.totalItems = this.allFeedItems.length;
        this.isSearching = false;
      } else {
        const searchTerm = this.searchTerm.toLowerCase().trim();
        this.feedItems = this.allFeedItems.filter((item) =>
          this.getSearchableText(item).toLowerCase().includes(searchTerm)
        );
        this.totalItems = this.feedItems.length;
        this.isSearching = true;
      }
    } else {
      if (!this.searchTerm || this.searchTerm.trim() === "") {
        this.facebookFeedItems = [...this.allFeedItems];
        this.totalItems = this.facebookFeedItems.length;
        this.isSearching = false;
      } else {
        this.applySearchFilter();
      }
    }
  }

  applyTiktokSearch(): void {
    if (!this.searchTerm || this.searchTerm.trim() === "") {
      const combinedFeeds = [...this.tiktokFeeds, ...this.tiktokMentions];
      this.feedItems = combinedFeeds;
      this.allFeedItems = combinedFeeds;
      this.totalItems = combinedFeeds.length;
      this.isSearching = false;
      this.currentPage = 1;
      return;
    }

    this.isSearching = true;
    this.currentPage = 1;

    const searchTerm = this.searchTerm.toLowerCase().trim();
    const combinedFeeds = [...this.tiktokFeeds, ...this.tiktokMentions];
    const filteredItems = combinedFeeds.filter((item) => {
      const searchableText = this.getSearchableText(item).toLowerCase();
      return searchableText.includes(searchTerm);
    });

    this.feedItems = filteredItems;
    this.allFeedItems = filteredItems;
    this.totalItems = filteredItems.length;
  }

  clearSearch(): void {
    this.searchTerm = "";
    this.isSearching = false;
    this.currentPage = 1;
    this.allItemsLoaded = false;

    this.totalItems = this.originalTotalItems;
    this.getFacebookPagePosts(this.facebookActivePage.id, true);
  }

  applySearchFilter(): void {
    if (!this.searchTerm || this.searchTerm.trim() === "") {
      this.isSearching = false;
      this.totalItems = this.originalTotalItems;

      if (
        this.allItemsLoaded &&
        this.allFeedItems.length >= this.originalTotalItems
      ) {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.feedItems = this.allFeedItems.slice(startIndex, endIndex);
      } else {
        this.getFacebookPagePosts(this.facebookActivePage.id, true);
      }
      return;
    }

    this.isSearching = true;
    this.currentPage = 1;

    if (!this.allItemsLoaded) {
      this.getFacebookPagePosts(this.facebookActivePage.id, true);
      return;
    }

    const searchTerm = this.searchTerm.toLowerCase().trim();
    this.facebookFeedItems = this.facebookFeedItems.filter((item) => {
      const searchableText = this.getSearchableText(item).toLowerCase();
      return searchableText.includes(searchTerm);
    });

    this.totalItems = this.facebookFeedItems.length;
  }

    getInitials(username: string): string {
      if (!username) {
        return 'FB';
      }
      return username.slice(0, 2).toUpperCase();
    }

  private getSearchableText(item: any): string {
    let searchableText = "";

    if (item.message) searchableText += item.message + " ";
    if (item.story) searchableText += item.story + " ";
    if (item.from && item.from.name) searchableText += item.from.name + " ";
    if (item.senderName) searchableText += item.senderName + " ";

    if (item.item) searchableText += item.item + " ";
    if (item.text) searchableText += item.text + " ";
    if (item.user && item.user.screen_name)
      searchableText += item.user.screen_name + " ";
    if (item.user && item.user.name) searchableText += item.user.name + " ";

    if (item.username) searchableText += item.username + " ";
    if (item.display_name) searchableText += item.display_name + " ";
    if (item.description) searchableText += item.description + " ";
    if (item.title) searchableText += item.title + " ";

    if (item.comments && item.comments.data) {
      item.comments.data.forEach((comment) => {
        if (comment.message || comment.text) {
          searchableText += (comment.message || comment.text) + " ";
        }
      });
    }

    if (item.commenter_display_name)
      searchableText += item.commenter_display_name + " ";
    if (item.comment_text) searchableText += item.comment_text + " ";
    if (item.caption) searchableText += item.caption + " ";

    if (item.comments && item.comments.data) {
      item.comments.data.forEach((comment) => {
        if (comment.message || comment.text) {
          searchableText += (comment.message || comment.text) + " ";
        }
      });
    }

    return searchableText.trim();
  }

  getDisplayItemsCount(): number {
    if (this.isSearching) {
      return this.feedItems.length;
    }
    return Math.min(this.currentPage * this.pageSize, this.totalItems);
  }

  getStartItemIndex(): number {
    if (this.isSearching) {
      return this.feedItems.length > 0 ? 1 : 0;
    }
    return this.totalItems > 0 ? (this.currentPage - 1) * this.pageSize + 1 : 0;
  }
}
